import { Component, ErrorInfo, PropsWithChildren, ReactElement } from 'react'

import GenericError from '@/components/genericError'

interface Props {
    fallback?: ReactElement
}

interface State {
    hasError: boolean
}

class ErrorBoundary extends Component<PropsWithChildren<Props>, State> {
    constructor(props: PropsWithChildren<Props>) {
        super(props)

        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error(error)
        console.error(info.componentStack)
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? <GenericError />
        }

        return this.props.children
    }
}

export default ErrorBoundary
